export const WHATSAPP_RAW = '5531997914679';
export const WHATSAPP_DISPLAY = '(31) 99791-4679';
export const EMAIL = 'davydespachante@gmail.com';
export const INSTAGRAM = '@davy_despachante_betim';
export const INSTAGRAM_URL = 'https://www.instagram.com/davy_despachante_betim';
export const ADDRESS = 'Rua de Pedestre, 151 — Jardim Teresópolis, Betim/MG';

export const waLink = (msg) =>
  `https://wa.me/${WHATSAPP_RAW}?text=${encodeURIComponent(msg)}`;

export const DEFAULT_WA_MESSAGE =
  'Olá Davy! Vim pelo seu site e preciso de um despachante.';

export const services = [
  {
    id: 'transferencia',
    title: 'Transferência de Veículo',
    category: 'Propriedade',
    description:
      'Transferência de titularidade no DETRAN-MG, estadual ou intermunicipal, sem filas e sem burocracia.',
    waMessage: 'Olá Davy! Gostaria de fazer a Transferência do meu veículo.',
    span: true,
  },
  {
    id: 'licenciamento',
    title: 'Licenciamento',
    category: 'Anual',
    description:
      'Emissão e regularização do CRLV-e atualizado junto ao sistema do DETRAN.',
    waMessage: 'Olá Davy! Preciso regularizar o Licenciamento do meu veículo.',
  },
  {
    id: 'emplacamento',
    title: 'Emplacamento',
    category: 'Placa Mercosul',
    description:
      'Troca e instalação de placas no Padrão Mercosul com agilidade garantida.',
    waMessage: 'Olá Davy! Preciso fazer o Emplacamento Mercosul.',
  },
  {
    id: 'primeiro-emplacamento',
    title: 'Primeiro Emplacamento',
    category: 'Veículo 0km',
    description:
      'Registro inicial de veículo zero quilômetro junto ao DETRAN-MG.',
    waMessage:
      'Olá Davy! Comprei um veículo 0km e preciso do Primeiro Emplacamento.',
  },
  {
    id: 'segunda-via',
    title: 'Segunda Via de Documento',
    category: 'Documentação',
    description:
      'Segunda via do CRV/CRLV-e em caso de perda, roubo, furto ou rasura.',
    waMessage:
      'Olá Davy! Preciso da Segunda Via do documento do meu veículo.',
  },
  {
    id: 'regularizacao',
    title: 'Regularização de Documentação',
    category: 'Pendências',
    description:
      'Resolução de bloqueios administrativos, restrições financeiras e pendências no registro.',
    waMessage:
      'Olá Davy! Tenho pendências na documentação do veículo e preciso regularizar.',
    span: true,
  },
  {
    id: 'comunicacao-venda',
    title: 'Comunicação de Venda',
    category: 'Segurança Jurídica',
    description:
      'Aviso oficial ao DETRAN sobre a venda do veículo — você se isenta de multas e débitos futuros.',
    waMessage: 'Olá Davy! Quero fazer a Comunicação de Venda do meu veículo.',
  },
  {
    id: 'consulta-debitos',
    title: 'Consulta de Débitos',
    category: 'Financeiro',
    description:
      'Levantamento completo de IPVA atrasado, taxas de licenciamento e seguro obrigatório.',
    waMessage: 'Olá Davy! Quero consultar os débitos do meu veículo.',
  },
  {
    id: 'consulta-multas',
    title: 'Consulta de Multas',
    category: 'Infrações',
    description:
      'Análise detalhada de multas estaduais e federais, com indicação de condutor.',
    waMessage: 'Olá Davy! Gostaria de consultar as multas do meu veículo.',
  },
  {
    id: 'alteracao-dados',
    title: 'Alteração de Dados do Veículo',
    category: 'Modificação',
    description:
      'Mudança de cor, combustível/GNC ou demais características no documento do veículo.',
    waMessage:
      'Olá Davy! Preciso alterar os dados do meu veículo no documento.',
  },
  {
    id: 'alvara-liberacao',
    title: 'Alvará de Liberação de Veículos',
    category: 'Urgente',
    description:
      'Retirada de veículos apreendidos em pátios do DETRAN e da Polícia, com prioridade total.',
    waMessage:
      'Olá Davy! Meu veículo foi apreendido e preciso do Alvará de Liberação urgente!',
    span: true,
  },
];

export const cities = [
  { name: 'Betim', base: true },
  { name: 'Contagem', base: true },
  { name: 'Belo Horizonte', base: true },
  { name: 'Ibirité', base: false },
  { name: 'Esmeraldas', base: false },
  { name: 'Ribeirão das Neves', base: false },
  { name: 'Santa Luzia', base: false },
  { name: 'Sabará', base: false },
];

export const faqs = [
  {
    q: 'Quanto tempo leva uma transferência de veículo?',
    a: 'Com a documentação em dia, o processo no DETRAN-MG costuma levar de 3 a 7 dias úteis. Eu acompanho cada etapa e te atualizo pelo WhatsApp.',
  },
  {
    q: 'Meu veículo está com débitos. Vocês resolvem?',
    a: 'Sim. Faço o levantamento completo de IPVA, multas e taxas, apresento o cenário com transparência e conduzo toda a regularização junto ao DETRAN-MG.',
  },
  {
    q: 'Meu carro foi apreendido. Como funciona o alvará de liberação?',
    a: 'É urgente e eu trato como prioridade: organizo a documentação exigida, protocolo o pedido e acompanho até a retirada do veículo no pátio.',
  },
  {
    q: 'Preciso ir até o DETRAN pessoalmente?',
    a: 'Na maioria dos serviços, não. Você me envia os documentos e eu cuido de todo o trâmite presencial e digital por você.',
  },
  {
    q: 'Atendem outras cidades além de Betim?',
    a: 'Sim. A base é Betim, Contagem e Belo Horizonte, mas atendo toda a região de Minas Gerais, com atendimento digital e presencial conforme a necessidade.',
  },
];
